import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth, googleProvider } from '../../firebase';
import { signInWithPopup } from 'firebase/auth';
import useLoginForm from '../../hooks/UseLoginForm';
import usersAPI from '../../api/users';

export default function AppLogin() {
  const navigate = useNavigate();
  const [googleLoading, setGoogleLoading] = useState(false);

  const {
    email,
    setEmail,
    password,
    setPassword,
    error,
    loading,
    handleSubmit,
  } = useLoginForm();

  // 🔁 Shared login success logic
  const handleLoginSuccess = async () => {
    try {
      const res = await usersAPI.getProfile();
      const profile = res.data;

      const isIncomplete =
        !profile.firstName || !profile.lastName || !profile.address?.country;

      if (isIncomplete) {
        navigate('/signup?step=2');
      } else {
        navigate('/dashboard');
      }
    } catch (err) {
      console.error('Profile check failed:', err.message);
      navigate('/dashboard');
    }
  };

  const signInWithProvider = async (provider) => {
    if (googleLoading) return;
    setGoogleLoading(true);

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      if (!user) throw new Error('Google login failed');
      await handleLoginSuccess();
    } catch (error) {
      console.error('Google Sign-In Error:', error.message);
      alert(error.message);
    } finally {
      setGoogleLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-screen justify-center items-center p-6 bg-light">
      <div className="w-full max-w-xs">
        <h2 className="text-3xl font-cormorant text-primary text-center mb-6">
          Welcome to Cantrysa
        </h2>
        <form onSubmit={(e) => handleSubmit(e, handleLoginSuccess)} className="bg-white shadow-md rounded p-6 w-full">
          {error && (
            <p className="text-red-500 text-sm mb-4 text-center">{error}</p>
          )}

          <label className="block mb-2 text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border rounded mb-4 focus:outline-none focus:ring focus:border-primary"
            required
          />

          <label className="block mb-2 text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 border rounded mb-4 focus:outline-none focus:ring focus:border-primary"
            required
          />

          <button
            type="submit"
            className="w-full bg-primary text-white py-2 rounded hover:bg-cream hover:text-primary"
          >
            Log In
          </button>

          <button
            onClick={() => signInWithProvider(googleProvider)}
            disabled={googleLoading}
            className="w-full mt-4 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            {googleLoading ? 'Signing in...' : 'Continue with Google'}
          </button>

          <div className="text-sm text-center text-text mt-3">
            No account?{" "}
            <Link to="/signup" className="text-primary hover:underline">
              Sign up
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}